<router-outlet> </router-outlet>
<input id="assetId" *ngIf="assetId$ | async" [hidden]="true" [ngModel]="assetId$ | async">